import { render, staticRenderFns } from "./StarRatingExecute.vue?vue&type=template&id=56d66727&scoped=true"
import script from "./StarRatingExecute.vue?vue&type=script&lang=js"
export * from "./StarRatingExecute.vue?vue&type=script&lang=js"
import style0 from "./StarRatingExecute.vue?vue&type=style&index=0&id=56d66727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d66727",
  null
  
)

export default component.exports